import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Box } from '@mui/material'

import SignOut from '@components/SignOut'
import SupportButton from '@components/SupportButton'
import LogoSection from '../../components/Logo'
import Drawer from './Drawer'
import MenuList from './MenuList'

import { useDrawer } from '../../hooks/useDrawer'
import { drawerMiniWidth, drawerWidth } from '../../store/constant'

import ConciergeSelector from '../../components/ConciergeSelector'

function Sidebar() {
  const { drawerOpen, isDrawerExpanded, isMiniDrawer } = useDrawer()

  if (isMiniDrawer && !drawerOpen) {
    return null
  }

  const width = isMiniDrawer ? drawerMiniWidth : drawerWidth
  return (
    <Box
      component='nav'
      sx={{
        flexShrink: 0,
        width,
      }}
      aria-label='mailbox folders'
    >
      <Drawer variant='permanent' drawerOpen={isDrawerExpanded}>
        <Box sx={{ display: 'flex', p: 1, minHeight: '70px' }}>
          <LogoSection />
        </Box>
        <Box
          sx={{
            bgcolor: 'grey.200',
            height: '100%',
            padding: isMiniDrawer ? '2rem .5rem' : '2rem 1rem 1rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <ConciergeSelector />
            <br />
            <MenuList />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <SignOut />

            <SupportButton>
              {isDrawerExpanded ? (
                'Contact Support'
              ) : (
                <HelpOutlineOutlinedIcon />
              )}
            </SupportButton>
          </Box>
        </Box>
      </Drawer>
    </Box>
  )
}

export default Sidebar
